var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"cont-list"},[_c('span',{staticClass:"list"},[_vm._v(_vm._s(this.parentRoute.menuName+'-'+this.route.menuName))])]),_c('Content',{attrs:{"isShowNo":_vm.isShowNo,"categoryName":_vm.categoryName,"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }